import { ReactNode, useRef } from 'react';
import { cn, Stack } from '@prenuvo/halo';

import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

import { PdfViewerDocument } from './pdf-viewer-document.component';
import { useWidth } from './use-width.hook';

interface PdfViewerProps {
  className?: string;
  error?: ReactNode;
  loading?: ReactNode;
  renderTextLayer?: boolean;
  url: string;
}

export function PdfViewer({
  className,
  error,
  loading,
  renderTextLayer = true,
  url,
}: PdfViewerProps) {
  const ref = useRef<HTMLDivElement>(null);
  const width = useWidth(ref);

  return (
    <Stack
      alignment="stretch"
      className={cn('pdf-viewer min-h-0 w-full min-w-0', className)}
      gap={0}
      ref={ref}
      variant="vertical"
    >
      <PdfViewerDocument
        key={url}
        error={error}
        loading={loading}
        renderTextLayer={renderTextLayer}
        url={url}
        width={width}
      />
    </Stack>
  );
}
